//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import truncate from 'lodash/truncate';
import ImageModal from "@/components/objects/ImageModal.vue";
import { AttrsListItem } from "@/utils/dto/objects.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "ImageWithDetailToTop",
  components: { TheMaskIcon },
  props: {
    item: {
      type: [Object, AttrsListItem],
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    objectId: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: ''
    },
    detail: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    expandId: {
      type: String,
      default: ''
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    changeDesignToggle: {
      type: Boolean
    },
    bgColor: {
      type: String
    },
    bgGradientEnabled: {
      type: Boolean,
    },
    bgGradientDirection: {
      type: String
    },
    bgGradientShadowDirection: {
      type: String
    },
    iconBgColor: {
      type: String
    },
    mask: {
      type: String
    },
    textColor: {
      type: [String, null],
      default: null
    },
  },
  data() {
    return {
      textClamp: true,
      latestWindowWidth: 280,
      colors: ['#dfb63e', '#66a664', '#eb7608', '#7c96b7'],
      isSmallDisplay: false,
      widthBlock: {
        width: '100%',
      },
      resizeRafId: null,
      pendingResizeForce: false
    }
  },
  computed: {
    isIndexOdd() {
      return this.index % 2 == 1
    },
    isIndexEven() {
      return this.index % 2 == 0
    },
    getBg() {
      if (this.bgGradientEnabled) {
        return `linear-gradient(to ${this.reverseGradientDirection(this.bgGradientDirection)}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor}, transparent` : `${this.bgColor}, ${adjustColorBrightness((this.bgColor), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      return null;
    },
    getImgStyle() {
      let src = this.$addServerPath(this.imagePath);
      // let color = this.myPaletteColors[this.index % this.myPaletteColors.length];
      let color = this.bgColor ?? this.colors[this.index % this.colors.length];
      const hueRotate = this.calculateHueRotate(color);
      const saturate = 100
      const filterStyle = `sepia(100%) hue-rotate(${hueRotate}deg) saturate(${saturate}%)`;

      return {
        backgroundImage: `url(${src})`,
        filter: filterStyle
      };
    },
    currentText() {
      return this.expand || this.detail ?
        this.item.fullText : this.customTruncate(this.item.shortText, this.isSmallDisplay ? 200 : this.latestWindowWidth < 768 ? 230 : this.latestWindowWidth < 800 ? 230 : this.latestWindowWidth < 960 ? 240 : this.latestWindowWidth < 1140 ? 230 : this.latestWindowWidth < 1200 ? 200 : this.latestWindowWidth < 1280 ? 170 : this.latestWindowWidth < 1360 ? 190 : this.latestWindowWidth < 1500 ? 230 : 200) //|| this.isSmallDisplay
    },
    isShowButtonExpand() {
      return (this.textClamp || this.expand) &&
        !(this.item.fullText == this.customTruncate(this.item.shortText, this.isSmallDisplay ? 200 : this.latestWindowWidth < 768 ? 230 : this.latestWindowWidth < 800 ? 230 : this.latestWindowWidth < 960 ? 240 : this.latestWindowWidth < 1140 ? 230 : this.latestWindowWidth < 1200 ? 200 : this.latestWindowWidth < 1280 ? 170 : this.latestWindowWidth < 1360 ? 190 : this.latestWindowWidth < 1500 ? 230 : 200))
    },
    expand() {
      return this.item.id === this.expandId
    },
    imagePath() {
      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.item.image_file)
      } else {
        return `/public/object_attrs_files/${this.objectId}/${this.item.id}/`
      }
    }
  },
  watch: {
    detail() {
      this.$nextTick(() => {
        this.scheduleResize()
      })
    },
    changeDesignToggle() {
      let timer;
      timer = setTimeout(() => {
        this.scheduleResize(true)

        timer = clearTimeout(timer);
      }, 600);
    },
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize, { passive: true })

    this.$nextTick(() => this.scheduleResize())
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
    if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId)
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    onWindowResize() {
      this.scheduleResize(false)
    },
    scheduleResize(force = false) {
      if (force) this._pendingResizeForce = true
      if (this.resizeRafId != null) return
      this.resizeRafId = requestAnimationFrame(() => {
        const useForce = this._pendingResizeForce || force
        this.resizeRafId = null
        this._pendingResizeForce = false
        this.resizeHandler(useForce)
      })
    },
    reverseGradientDirection(direction) {
      switch (direction) {
      case 'top':
        return 'bottom';
      case 'bottom':
        return 'top';
      case 'left':
        return 'right';
      case 'right':
        return 'left';
      }
    },
    customTruncate(text, maxLength = 200) {
      if (text.length <= maxLength) {
        return text;
      }
      return truncate(text, {
        length: maxLength,
        omission: '...',
        separator: ' '
      });
    },
    calculateHueRotate(hexColor) {
      // Убираем знак # если он есть
      hexColor = hexColor.replace(/^#/, '');

      // Преобразуем HEX в RGB
      let r = parseInt(hexColor.substring(0, 2), 16) / 255;
      let g = parseInt(hexColor.substring(2, 4), 16) / 255;
      let b = parseInt(hexColor.substring(4, 6), 16) / 255;

      let max = Math.max(r, g, b), min = Math.min(r, g, b);
      let h, s, l = (max + min) / 2;
      if (max === min) {
        h = s = 0; // achromatic
      } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
      }
      return (h * 360) - 35;
    },
    resizeHandler(force = false) {
      try {
        if (this.latestWindowWidth === window.innerWidth && !force) return
        this.latestWindowWidth = window.innerWidth
        this.$emit('expand', '')
        this.isSmallDisplay = this.latestWindowWidth <= 640

        const ITEM_BOX = this.$refs['item'].parentNode

        if (ITEM_BOX) {
          const ITEM_BOX_WIDTH = ITEM_BOX.clientWidth
          const IMAGE_WIDTH = Math.round(ITEM_BOX_WIDTH * (this.isSmallDisplay ? 0.37 : 0.30))

          this.$refs['item-image'].style.setProperty('width', `${IMAGE_WIDTH}px`)
          this.$emit('attrs-first-width', IMAGE_WIDTH)

          // const IMAGE_HEIGHT = IMAGE_WIDTH + 15

          if (!this.detail) {
            const ITEMS = ITEM_BOX.querySelectorAll('.item')

            ITEMS.forEach(el => {
              el.style.removeProperty('height')
              el.style.removeProperty('min-height')
            })

            let max_item_height = 0
            ITEMS.forEach(el => {
              const naturalHeight = el.clientHeight
              if (naturalHeight > max_item_height) {
                max_item_height = naturalHeight
              }
            })

            const targetHeight = max_item_height - 10
            ITEMS.forEach(el => {
              el.style.setProperty('height', `${targetHeight}px`)
              el.style.setProperty('min-height', `${targetHeight < 120 ? 120 : targetHeight}px`)
            })
          }

          let width = this.isSmallDisplay ? '100%' : Math.round(ITEM_BOX_WIDTH / 2 + (IMAGE_WIDTH / 2)) + 'px';
          this.widthBlock = {
            width: `${width}`,
          };
        }

        const STYLE_BOX = getComputedStyle(this.$refs['text-box'])
        const STYLE_BOX_HEIGHT = Math.floor(this.$refs['text-box'].clientHeight - (parseFloat(STYLE_BOX.paddingBottom) + parseFloat(STYLE_BOX.paddingTop)))
        const REAL_HEIGHT_FOR_TEXT = Math.floor(STYLE_BOX_HEIGHT - (this.$refs.title.clientHeight + this.$refs['expand_block'].clientHeight))

        let line_clamp = Math.floor(REAL_HEIGHT_FOR_TEXT / parseInt(getComputedStyle(this.$refs.text).lineHeight))
        line_clamp = (this.latestWindowWidth < 640 && line_clamp > 6)
          ? 6
          : ((this.latestWindowWidth >= 640 && line_clamp >= 8) ? line_clamp - 1 : line_clamp)

        this.$refs['text-box'].style.setProperty(
          '--line-clamp',
          line_clamp
        )

        let boxHeight = this.$refs['text-box'].clientHeight

        if (this.detail) boxHeight = this.$refs['item'].clientHeight

        this.$refs['text-box'].style.setProperty('--box-height', `${boxHeight}px`)
        this.textClamp = Boolean(this.$refs.text.scrollHeight > REAL_HEIGHT_FOR_TEXT || this.currentText.length < this.item.fullText.length)
      }
      catch (e) {

      }
    },
    handleSelfExpand() {
      if (!this.textClamp || this.detail) return

      if (this.expand) {
        this.$emit('expand', '')
      } else {
        this.$emit('expand', this.item.id)
      }
    },
    openPopup() {
      this.$vfm.show({
        component: ImageModal,
        bind: {
          src: this.$addServerPath(this.imagePath),
          label: this.item.label || "Без названия",
          source: this.item.image_url
        },
        on: {
          'before-open': () => {
            this.isOpen = true
          },
          'closed': () => {
            this.isOpen = false
          }
        }
      })
    }
  }
}
